// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { QA_URL, QA_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { QaIndex } = lazily(() => import('pages/back-office/qa/qa'))

const qaIndexRoutes: IRoute[] = [
  {
    path: QA_URL.INDEX,
    component: QaIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: QA_MODULE,
      requireAuth: true,
      attrs: {
        label: 'qa.manageQa',
        accessCodes: [882],
      },
    },
  },
]

export { qaIndexRoutes }
